import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const get = async (url, params, fallback) => {
    try {
        const r = await axios.get(`${API_BASE_URL}${url}`, { params });
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const post = async (url, payload, fallback) => {
    try {
        const r = await axios.post(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const put = async (url, payload, fallback) => {
    try {
        const r = await axios.put(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

// ── Lookups ──────────────────────────────────────────────────────────────────

export const getMasterWorkFlowStatus = (Masterids, Roleid) =>
    get('/Accounts/GetMasterWorkFlowStatus', { Masterids, Roleid }, 'Failed to fetch workflow status');
export const getAllDCA = () => get('/Accounts/GetAllDCA', {}, 'Failed to fetch account heads');
export const getSubDCAByDCA = (DCACode) => get('/Accounts/GetSubDCAbyDCA', { DCACode }, 'Failed to fetch sub account heads');
export const getStatesList = () => get('/Accounts/GetStatesList', {}, 'Failed to fetch states');
export const getTaxItCodes = () => get('/Accounts/GetTaxItCodes', {}, 'Failed to fetch IT codes');
export const getItCodeGroupDetails = (ItId) => get('/Accounts/GetItCodeGroupDetails', { ItId }, 'Failed to fetch IT code group details');

// ── General Tax ──────────────────────────────────────────────────────────────

export const getAllGeneralTaxDetails = () => get('/Accounts/GetAllGeneralTaxDetials', {}, 'Failed to fetch general taxes');
export const saveGeneralTax = (payload) => post('/Accounts/SaveGeneralTax', payload, 'Failed to save tax');
export const updateGeneralTax = (payload) => put('/Accounts/UpdateGeneralTax', payload, 'Failed to update tax');
export const getVerificationGeneralTaxById = (Taxid) =>
    get('/Accounts/GetVerificationGeneralTaxesbyid', { Taxid }, 'Failed to fetch tax details');

// ── GST Tax ──────────────────────────────────────────────────────────────────

export const getAllGstTaxDetails = () => get('/Accounts/GetAllGstTaxDetials', {}, 'Failed to fetch GST taxes');
export const saveGstTax = (payload) => post('/Accounts/SaveGstTax', payload, 'Failed to save GST');
export const updateGstTax = (payload) => put('/Accounts/UpdateGstTax', payload, 'Failed to update GST');
export const getVerificationGstTaxById = (Taxid) =>
    get('/Accounts/GetVerificationGstTaxebyid', { Taxid }, 'Failed to fetch GST details');
